import { HttpErrorResponse } from "@angular/common/http";

/**
 * AppHttpErrorResponse extends HttpErrorResponse.
 *
 * ApiResponseError is used as the default type for the error attribute,
 * you can use another type if required.
 *
 * @template E type used for error attribute
 * @example let error: AppHttpErrorResponse;
 * @example let error: AppHttpErrorResponse<NewErrorType>;
 */
export class AppHttpErrorResponse<E = unknown> extends HttpErrorResponse {
  override readonly error: E | null;
  readonly _parsedBlob: unknown;
  /** control flag to help error handling by the application */
  _wasInterceptedByApp?: boolean;
  constructor(
    init: Omit<ConstructorParameters<typeof HttpErrorResponse>[0], "error"> & {
      error?: E;
      _wasInterceptedByApp?: boolean;
      _parsedBlob?: unknown;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...rest: ConstructorParameters<typeof HttpErrorResponse> extends [first: any, ...other: infer R] ? R : never
  ) {
    super(init, ...rest);
    this.error = init.error ?? null;
    this._wasInterceptedByApp = init._wasInterceptedByApp ?? false;
    this._parsedBlob = init._parsedBlob ?? null;
  }

  static isInterceptedByApp(value: unknown): boolean {
    try {
      return Boolean(value && typeof value === "object" && (<AppHttpErrorResponse>value)._wasInterceptedByApp);
    } catch {
      return false;
    }
  }
}
